export default __webpack_public_path__ + "static/media/certificate.d61d9bf7.png";